module.exports = __webpack_public_path__ + "static/media/buildings.47bde912.svg";